import React from 'react';
import PropTypes from 'prop-types';
import { Link } from '@bd/bdcore-named-routes';
import { get } from 'lodash';
import { css } from '@bd/bdui-styles/emotion';

const styles = css`
  margin-bottom:15px;
  .buttonSet__container {
    margin:0 -2px;
    display:flex;
    flex-flow:row wrap;
    justify-content:flex-start;
    &.left {
      justify-content:flex-start;
    }
    &.center {
      justify-content:center;
    }
    &.right {
      justify-content:flex-end;
    }
  }
  .buttonSet__containerColumn {
    padding:2px;
    width:100%;
    @media (min-width: 992px) {
      width:auto;
    }
    .btn {
      width:100%;
      @media (min-width: 480px) {
        width:auto;
      }
    }
  }
`;

function ButtonSetBanner({ content }) {
  const buttonSet = get(content, 'button_set[0]');
  const buttons = get(buttonSet, 'buttons', []).filter(button => get(button, 'button_label'));

  if (!buttons.length === 0) {
    return null;
  }

  return (
    <div className="buttonSet">
      <div className={styles}>
      test
        <ul className={`list-unstyled buttonSet__container ${get(buttonSet, 'alignment')}`}>
          {
            buttons.map(button => {
              const buttonClass = ['btn', button.button_color, button.button_icon].filter(v => v).join(' ');
              const type = get(button, 'button_type');

              return (
                <li className="buttonSet__containerColumn" key={button.button_label}>
                  {
                    type !== 'Route' &&
                    <a
                      href={`${type === 'Phone' ? 'tel:' : ''}${get(button, type === 'File' ? 'pdf_file_upload.contentUrl' : 'button_path')}`}
                      className={buttonClass}
                      target={get(button, 'open_in_new_tab') ? '_blank' : undefined}
                      rel="noopener noreferrer"
                    >
                      {get(button, 'button_label')}
                    </a>
                  }
                  {
                    type === 'Route' &&
                    <Link
                      className={buttonClass}
                      name={get(button, 'button_path')}
                      target={button.open_in_new_tab ? '_blank' : undefined}
                      rel="noopener noreferrer"
                    >
                      {get(button, 'button_label')}
                    </Link>
                  }
                </li>
              );
            })
          }
        </ul>
      </div>
    </div>
  );
}

ButtonSetBanner.propTypes = {
  content: PropTypes.arrayOf(PropTypes.object).isRequired,
};

ButtonSetBanner.defaultProps = {
};

export default ButtonSetBanner;



// WEBPACK FOOTER //
// ./src/components/PageLoader/Sections/ButtonSetBanner.section.js